import React from 'react';

const Speedometer = ({ currentPhase, currentSpeed, results, isActive, progress }) => {
  return (
    <div className="flex flex-col items-center mb-8">
      <div className="relative w-64 h-64 mb-6">
        {/* Speedometer Background */}
        <div className="absolute inset-4 bg-gradient-to-br from-[#1E9B4C]/20 to-green-600/20 dark:from-green-500/20 dark:to-green-600/20 rounded-full"></div>
        <div className="absolute inset-6 bg-white dark:bg-gray-900 rounded-full"></div>
        
        {/* Speed Display */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <div className="text-4xl font-bold mb-1 text-[#1E9B4C] dark:text-green-400">
            {currentPhase === 'idle' ? '0' : 
             currentPhase === 'complete' ? results.downloadSpeed.toFixed(1) :
             currentSpeed.toFixed(1)}
          </div>
          <div className="text-gray-600 dark:text-gray-400 text-sm">
            {currentPhase === 'ping' ? 'Testing...' :
             currentPhase === 'download' ? 'Download' :
             currentPhase === 'upload' ? 'Upload' : 'Mbps'}
          </div>
        </div>

        {/* Pulse Animation when Active */}
        {isActive && (
          <div className="absolute inset-0 border-2 border-[#1E9B4C] dark:border-green-500 rounded-full pulse-ring"></div>
        )}
      </div>

      {/* Progress Bar */}
      <div className="w-full max-w-md mb-6">
        <div className="speed-bar bg-gray-200 dark:bg-gray-700 rounded-full h-2">
          <div 
            className="speed-indicator bg-gradient-to-r from-[#1E9B4C] to-green-600 dark:from-green-500 dark:to-green-600 h-2 rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <div className="flex justify-between text-xs text-gray-600 dark:text-gray-400 mt-2">
          <span>Ping</span>
          <span>Download</span>
          <span>Upload</span>
        </div>
      </div>
    </div>
  );
};

export default Speedometer;